import { filter, map } from "rxjs";
import { Component, HostBinding, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { WtfAnimations } from "../../../utils/others/core/animations";
import { WtfConfigService } from "../../../services/core/config.service";
import { Subscription } from "rxjs";

@Component({
    selector: "wtf-content",
    templateUrl: "./content.component.html",
    styleUrls: ["./content.component.scss"],
    animations: WtfAnimations,
})
export class WtfContentComponent implements OnInit, OnDestroy {
    onSettingsChanged: Subscription;
    wtfSettings: any;

    @HostBinding("@routerTransitionUp") routeAnimationUp = false;
    @HostBinding("@routerTransitionDown") routeAnimationDown = false;
    @HostBinding("@routerTransitionRight") routeAnimationRight = false;
    @HostBinding("@routerTransitionLeft") routeAnimationLeft = false;
    @HostBinding("@routerTransitionFade") routeAnimationFade = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private wtfConfig: WtfConfigService
    ) {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute)
            )
            .subscribe((event) => {
                switch (this.wtfSettings.routerAnimation) {
                    case "fadeIn":
                        this.routeAnimationFade = !this.routeAnimationFade;
                        break;
                    case "slideUp":
                        this.routeAnimationUp = !this.routeAnimationUp;
                        break;
                    case "slideDown":
                        this.routeAnimationDown = !this.routeAnimationDown;
                        break;
                    case "slideRight":
                        this.routeAnimationRight = !this.routeAnimationRight;
                        break;
                    case "slideLeft":
                        this.routeAnimationLeft = !this.routeAnimationLeft;
                        break;
                }
            });

        this.onSettingsChanged = this.wtfConfig.onSettingsChanged.subscribe(
            (newSettings) => {
                this.wtfSettings = newSettings;
            }
        );
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.onSettingsChanged.unsubscribe();
    }
}
